import { render, staticRenderFns } from "./Videojs.vue?vue&type=template&id=195e152f&scoped=true&"
import script from "./Videojs.vue?vue&type=script&lang=js&"
export * from "./Videojs.vue?vue&type=script&lang=js&"
import style0 from "./Videojs.vue?vue&type=style&index=0&id=195e152f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e152f",
  null
  
)

export default component.exports